import Vue from "vue";
import VueRouter from "vue-router";
import homeRoutes from "home/homeRoutes"
import recruitRoutes from "recruit/recruitRoutes"
import liveRoutes from "live/liveRoutes"
import meetingRoutes from "meeting/meetingRoutes"
import imRoutes from "im/imRoutes"
import questionnaireRoutes from "questionnaire/questionnaireRoutes"
import loginRoutes from "login/loginRoutes"
import companyRoutes from "company/companyRoutes"
import companyManageRoutes from "companyManage/companyManageRoutes"
import studentManageRoutes from "studentManage/studentManageRoutes"
import noticeRoutes from "notice/noticeRoutes"
import systemConfigRoutes from "systemConfig/systemConfigRoutes"
import studentRoutes from "student/studentRoutes"
Vue.use(VueRouter);
const defaultSettings = require("../config.js");


const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/views/index"),
    redirect:'/login/teacherLogin'
  },
  {
    path: "/writeQuestion",
    name: "writeQuestion",
    component: () => import("@/views/writeQuestion"),
  },
  homeRoutes,
  recruitRoutes,
  liveRoutes,
  meetingRoutes,
  imRoutes,
  questionnaireRoutes,
  loginRoutes,
  companyRoutes,
  companyManageRoutes,
  studentManageRoutes,
  noticeRoutes,
  systemConfigRoutes,
  studentRoutes
]


const router = new VueRouter({
  scrollBehavior(to) {
    return {x:0,y:0}
  },
  mode:'history',
  base: process.env.NODE_ENV === "test"?`/${defaultSettings.name}`:'/',
  routes
});

export default router;
